import React from "react";
import CobrarPedidos from "../../../../../../../Common/CobrarPedidos/CobrarPedidos";
import { Modal } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";
import './CobrarPedido.scss';

interface CobrarPedidoProps {
    pedido: any;
    setPedidos: any;
    show: boolean;
    setShow: (show: boolean) => void;
}

const CobrarPedido: React.FC<CobrarPedidoProps> = ({
    pedido,
    setPedidos, 
    show, 
    setShow}) => {
    
    // Determine pedido_type based on whether it's a delivery app order or in-house
    const pedidoType = pedido.third_party_provider_id ? "Delivery" : "Caja";
    
    return (
        <Modal 
            show={show} 
            onHide={() => setShow(false)} 
            centered 
            size="lg"
            dialogClassName="cobrar-pedido-modal"
        >
            <Modal.Header closeButton={false}>
                <div className="form-modal-title-container">
                    <h2 className="form-modal-title">Cobrar Pedido</h2>
                </div>
                <button 
                    className="modal-close-button"
                    onClick={() => setShow(false)}
                    aria-label="Cerrar"
                >
                    <FaTimes size={18} />
                </button>
            </Modal.Header>
            <Modal.Body>
            <CobrarPedidos
                client_id={pedido.client_id}
                client_name={pedido.client_name}
                pedido={pedido}
                show={show}
                onHide={() => setShow(false)}
                onClose={() => setShow(false)}
                allowSplit={true}
                pedido_type={pedidoType}
                setPedidos={setPedidos}
            />
            </Modal.Body>
        </Modal>
    );
}

export default CobrarPedido;





